import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useOutletContext } from "react-router-dom";
import { toast } from "react-toastify";
import { formatToZMW, handleExcel, handlePrint, rootUrl, sumOfArray } from "../../helpers";
import { CiBank } from "react-icons/ci";
import { BiCheckCircle } from "react-icons/bi";
import { useAuth } from "../../context/auth-context";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { FaFileExcel, FaPrint, FaTrash, FaFilePdf, FaLock, FaUnlock } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

export default function Recon() {
  const [months] = useState([
    { month: "January", value: 1 },
    { month: "February", value: 2 },
    { month: "March", value: 3 },
    { month: "April", value: 4 },
    { month: "May", value: 5 },
    { month: "June", value: 6 },
    { month: "July", value: 7 },
    { month: "August", value: 8 },
    { month: "September", value: 9 },
    { month: "October", value: 10 },
    { month: "November", value: 11 },
    { month: "December", value: 12 },
  ]);

  const {allData, setAllData} = useOutletContext();
  const [banks, setBanks] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedBank, setSelectedBank] = useState("");
  const [open, setOpen] = useState(0);
  const [receipts, setReceipts] = useState(0.0);
  const [payments, setPayments] = useState(0.0);
  const [closing, setClosing] = useState(0.0);
  const [loading, setLoading] = useState(false);
  const [cashData, setCashData] = useState([]);
  const [amount, setAmount] = useState(0.0);

  const [dummy, setDummy] = useState(0.0);
  const [desc, setDesc] = useState('');
  const [type, setType] = useState('');
  const [date, setDate] = useState('');

  const [year, setYear] = useState('');

  const [dummies, setDummies] = useState([]);
  const [isLocked, setIsLocked] = useState(false);
  

  const componentRef = useRef(null)

  useEffect(() => {
    if(allData.bank){
      setBanks(allData.bank);
    }
    
  }, [allData.bank]);

  const reconcile = async () => {
    setLoading(true)

    if(selectedBank.length == 0 || selectedMonth.length == 0 || year.length == 0 ){
      toast.error("Ensure to select all fields")
      return

    }

    try {
      const response = await axios.post(rootUrl(`/bankRec`), {
        month: selectedMonth,
        bank: selectedBank,
        year:year
      });
     
      setCashData(response.data.trans);
      setDummies(response.data.dummy)
      setAmount(response.data.recon[0]?.amount || 0);
      setOpen(parseFloat(response.data.cash[0]?.diff) || 0);
      setIsLocked(response.data.recon[0]?.locked == 1 || false);
      setLoading(false)
    } catch (error) {
      toast.error("Error fetching reconciliation data");
    }
  };

  const auth = useAuth();
  const isAdmin = auth.user?.userType == 2;

  const addDummy = async () => {
    if (isLocked) {
      toast.error("This month is locked. Lodgements cannot be changed.");
      return;
    }

    if(dummy.length == 0 || desc.length == 0 || type.length == 0){
      toast.error("Ensure to fill in all fields")
      return
    }
    const payload = {
      amount:dummy,
      description:desc,
      type:type,
      uid:auth.user.id,
      month:selectedMonth,
      bank:selectedBank,
      date:date,
      year:year
    }

    // setDummies([...dummies, payload])

    const response = await axios.post(rootUrl(`/postDummy`), payload)
    if(response.data.status == 200){
      setDummies(response.data.data)
      setType('')
      setDummy('')
      setDesc('')
      setDate('')
    } else if (response.data.status === 403) {
      toast.error(response.data.message || "Month is locked. Lodgements cannot be changed.");
    }
    

  }
  

  const delDummy =  (id) =>{
    if (isLocked) {
      toast.error("This month is locked. Lodgements cannot be changed.");
      return;
    }
    try{

      axios.get(rootUrl(`/delDummy/${id}`))
      setDummies(prevItems => prevItems.filter(item => item.id !== id));

    }catch(e){
      toast.error(e?.message)
    }

  }

  
  const markAsReconciled = async (obj) => {
    if (isLocked) {
      toast.error("This month is locked. Reconciliation cannot be changed.");
      return;
    }
    try {

      const payload = {
        voucher:obj.voucher, 
        cheque :obj.cheque,
        date:obj.date,
        cid: auth.user.cid,
        recon:obj.recon
      }
      const resp = await axios.post(rootUrl(`/markReconciled`), payload);
      if (resp.data.status === 403) {
        toast.error(resp.data.msg || "Month is locked. Reconciliation cannot be changed.");
        return;
      }
      if (resp.data.status === 200) {
        setCashData((prevData) =>
          prevData.map((item) => (item.voucher === obj.voucher && item.cheque === obj.cheque && item.date === obj.date ? { ...item, recon: obj.recon == 1?0:1 } : item))
        );

        obj.recon == 0?toast.success("Item marked as reconciled"):toast.info("Item has be unreconciled");       
        
      } else {
        toast.error(resp.data.msg);
      }
    } catch (error) {
      toast.error("Error marking item as reconciled");
    }
  };

  const addAmount = async () =>{
      if (isLocked) {
        toast.error("This month is locked. Bank balance cannot be changed.");
        return;
      }
      const data = {
        "month":selectedMonth,
        "bank":selectedBank,
        "amount":amount,
        "year":year
      }

      const resp = await axios.post(rootUrl(`/addAmount`), data)
      if(resp.data.status == 200){

        toast.success("Successful")
      } else if (resp.data.status === 403) {
        toast.error(resp.data.message || "Month is locked. Bank balance cannot be changed.");
      } else {
        toast.error(resp.data.message || "Something went wrong")
      }

  }

  const lockMonth = async () => {
    if(selectedBank.length == 0 || selectedMonth.length == 0 || year.length == 0 ){
      toast.error("Ensure to select all fields")
      return
    }

    try {
      const response = await axios.post(rootUrl(`/lockMonth`), {
        month: selectedMonth,
        bank: selectedBank,
        year: year,
        cid: auth.user?.cid
      });
      
      if(response.data.status == 200){
        setIsLocked(true);
        toast.success("Month locked successfully. No new transactions can be added to this month.");
      } else {
        toast.error("Failed to lock month");
      }
    } catch (error) {
      toast.error("Error locking month");
    }
  }

  const unlockMonth = async () => {
    if (!isAdmin) {
      toast.error("Only an administrator can unlock a locked month.");
      return;
    }
    if(selectedBank.length == 0 || selectedMonth.length == 0 || year.length == 0 ){
      toast.error("Ensure to select all fields")
      return
    }

    try {
      const response = await axios.post(rootUrl(`/unlockMonth`), {
        month: selectedMonth,
        bank: selectedBank,
        year: year,
        uid: auth.user?.id
      });
      
      if(response.data.status == 200){
        setIsLocked(false);
        toast.success("Month unlocked successfully. Transactions can now be added to this month.");
      } else {
        toast.error(response.data.message || "Failed to unlock month");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Error unlocking month");
    }
  }

  const incomeData = cashData?.filter((item) => item.type === "income");
  const expenseData = cashData?.filter((item) => item.type === "expense");

  const [hideReconciled, setHideReconciled] = useState(false);

const filteredIncomeData = hideReconciled ? incomeData.filter(a => a.recon != '1') : incomeData;
const filteredExpenseData = hideReconciled ? expenseData.filter(a => a.recon != '1') : expenseData;

  useEffect(()=>{
    setReceipts(sumOfArray(incomeData?.filter(a=>a.recon == 1).map(res=>parseFloat(res.amount))))
    setPayments(sumOfArray(expenseData?.filter(a=>a.recon == 1).map(res=>parseFloat(res.amount))))
  },[cashData])

  const [dummyTotal ,setDummyTotal] = useState(0.0)

  useEffect(()=>{
    setDummyTotal(sumOfArray(dummies.filter(a=>a.type == 'income').map(res=>parseFloat(res.amount))) - sumOfArray(dummies.filter(a=>a.type == 'expense').map(res=>parseFloat(res.amount))))
  },[dummies])

  
  const totalReceipts = incomeData?.reduce((sum, item) => sum + parseFloat(item.amount), 0);
  const totalPayments = expenseData?.reduce((sum, item) => sum + parseFloat(item.amount), 0);
  const closingBalance = open + totalReceipts - totalPayments;

  const handleExportToPDF = () => {
    const input = componentRef.current;
    if (!input) return;
    
    html2canvas(input, {
      scrollY: -window.scrollY,
      scale: 2,
      useCORS: true,
      onclone: (clonedDoc) => {
        clonedDoc.querySelectorAll(".recon-hide-from-export").forEach((el) => el.remove());
      },
    }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      
      // Calculate the height of the content in the PDF
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;
      const imgHeight = (canvasHeight * pdfWidth) / canvasWidth;
      let heightLeft = imgHeight;
      
      let position = 0;
      
      // Add the first page
      pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, imgHeight);
      heightLeft -= pdfHeight;
      
      // Add more pages if needed
      while (heightLeft > 0) {
        position -= pdfHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, imgHeight);
        heightLeft -= pdfHeight;
      }
      
      const monthName = months.find(a => a.value == selectedMonth)?.month || 'Month';
      const bankName = allData.bank.find(a => a.id == selectedBank)?.name || 'Bank';
      const fileName = `Bank_Reconciliation_${monthName}_${year}_${bankName.replace(/\s+/g, '_')}.pdf`;
      pdf.save(fileName);
    });
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-950 to-blue-800 rounded-2xl p-6 text-white shadow-lg">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <div className="bg-white/20 rounded-xl p-3">
              <CiBank className="text-2xl" />
            </div>
            <div>
              <h1 className="text-2xl md:text-3xl font-bold">Bank Reconciliation</h1>
              <p className="text-blue-100 text-sm mt-1">
                Reconcile bank statements with your cashbook balances.
              </p>
            </div>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            <button
              onClick={handleExportToPDF}
              className="inline-flex items-center bg-white/20 hover:bg-white/30 text-white px-3 py-2 rounded-lg text-xs md:text-sm font-medium transition-colors border border-white/30"
              title="Export to PDF"
            >
              <FaFilePdf className="inline mr-1" />
              PDF
            </button>
            <button
              onClick={() => handleExcel(componentRef, 'recon')}
              className="inline-flex items-center bg-white/20 hover:bg-white/30 text-white px-3 py-2 rounded-lg text-xs md:text-sm font-medium transition-colors border border-white/30"
              title="Export to Excel"
            >
              <FaFileExcel className="inline mr-1" />
              Excel
            </button>
            <button
              type="button"
              onClick={() => handlePrint(componentRef)}
              className="inline-flex items-center bg-white/20 hover:bg-white/30 text-white px-3 py-2 rounded-lg text-xs md:text-sm font-medium transition-colors border border-white/30"
              title="Print"
            >
              <FaPrint className="inline mr-1" />
              Print
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="w-full bg-white rounded-2xl p-4 md:p-6 shadow-sm border border-gray-100">

      {/* Filters and toggle */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-4">
        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            id="toggleReconciled"
            checked={hideReconciled}
            onChange={() => setHideReconciled(!hideReconciled)}
            className="h-4 w-4"
          />
          <label htmlFor="toggleReconciled" className="text-sm text-gray-700">
            Hide Reconciled Transactions
          </label>
        </div>
        {!loading && selectedMonth && selectedBank && year && (
          <div className="flex flex-wrap items-center gap-2">
            {isLocked ? (
              isAdmin ? (
                <button
                  type="button"
                  onClick={unlockMonth}
                  className="inline-flex items-center gap-2 bg-yellow-600 hover:bg-yellow-700 text-white px-4 py-2 rounded-lg text-sm font-semibold transition-colors"
                  title="Unlock this month (admin only)"
                >
                  <FaUnlock className="text-sm" />
                  Unlock Month
                </button>
              ) : (
                <span className="text-sm text-amber-800 bg-amber-50 border border-amber-200 px-3 py-2 rounded-lg">
                  This month is locked. Only an administrator can unlock it.
                </span>
              )
            ) : (
              <button
                type="button"
                onClick={lockMonth}
                className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg text-sm font-semibold transition-colors"
                title="Lock this month to prevent changes"
              >
                <FaLock className="text-sm" />
                Lock Month
              </button>
            )}
          </div>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 mb-6">
        <select
          className="border border-gray-300 rounded-lg p-2 w-full text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={selectedMonth}
          onChange={(e) => setSelectedMonth(e.target.value)}
        >
          <option value="">Select Month</option>
          {months.map((month) => (
            <option key={month.value} value={month.value}>{month.month}</option>
          ))}
        </select>
        <select
          className="border border-gray-300 rounded-lg p-2 w-full text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={selectedBank}
          onChange={(e) => setSelectedBank(e.target.value)}
        >
          <option value="">Select Bank</option>
          {banks.map((bank) => (
            <option key={bank.id} value={bank.id}>{bank.name}</option>
          ))}
        </select>
        <select
          className="border border-gray-300 rounded-lg p-2 w-full text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={year}
          onChange={(e) => setYear(e.target.value)}
        >
          <option value="">Select Year</option>
          {[2024, 2025, 2026].map((yr) => (
            <option key={yr} value={yr}>{yr}</option>
          ))}
        </select>
        <button
          onClick={reconcile}
          className="bg-blue-950 hover:bg-blue-800 text-white font-semibold py-2 px-4 rounded-lg text-sm"
        >
          Submit
        </button>
      </div>

      {/* Main content */}
      {loading ? (
        <div className="min-h-[50vh] bg-gray-50 p-6 rounded-xl border border-dashed border-gray-200 flex items-center justify-center">
          <div className="max-w-3xl w-full">
            <Skeleton count={4} height={60} className="mb-4" />
          </div>
        </div>
      ) : (
        <>
          <div ref={componentRef} className="mt-2">
            <div className="text-center mb-4">
              <div className="flex items-center justify-center gap-3 mb-2">
                <h2 className="font-bold text-xl md:text-2xl text-gray-900">
                  {allData.council[0]?.name.toUpperCase()}
                </h2>
                {isLocked && (
                  <div
                    className="recon-hide-from-export flex items-center gap-2 bg-red-100 text-red-700 px-3 py-1 rounded-full text-sm font-semibold"
                    aria-hidden="true"
                  >
                    <FaLock className="text-sm" />
                    <span>LOCKED</span>
                  </div>
                )}
              </div>
              <h3 className="text-sm md:text-lg font-semibold text-gray-800 mt-1">
                {`Bank Reconciliation statement for the month of`.toUpperCase()}{" "}
                {months.find(a=>a.value == selectedMonth)?.month?.toUpperCase()}, {year}
              </h3>
              <h3 className="text-sm md:text-lg font-semibold text-gray-800 mt-1">
                {allData.bank.find(a=>a.id == selectedBank)?.name}
              </h3>
            </div>

            {/* Summary card */}
            <div className="bg-white rounded-xl border border-gray-200 p-4 mb-4">
              <h2 className="text-lg font-bold text-gray-700 mb-2">Summary</h2>
              <table className="w-full text-left border-collapse text-sm">
                <tbody>
                  <tr className="border-b">
                    <td className="py-2 px-2 md:px-4 font-medium text-gray-700">Opening Balance:</td>
                    <td className="py-2 px-2 md:px-4">{formatToZMW(open)}</td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 px-2 md:px-4 font-medium text-gray-700">Total Receipts:</td>
                    <td className="py-2 px-2 md:px-4">{formatToZMW(totalReceipts)}</td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-2 px-2 md:px-4 font-medium text-gray-700">Total Payments:</td>
                    <td className="py-2 px-2 md:px-4">{formatToZMW(totalPayments)}</td>
                  </tr>
                  <tr className="border-t font-bold text-blue-600">
                    <td className="py-2 px-2 md:px-4">Closing Balance:</td>
                    <td className="py-2 px-2 md:px-4">{formatToZMW(closingBalance)}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Detail tables */}
            <Table
              title="Less Uncredited Deposits"
              data={filteredIncomeData}
              markAsReconciled={markAsReconciled}
              total={sumOfArray(filteredIncomeData.map(res=>parseFloat(res.amount)))}
              suppliers={allData.suppliers}
              locked={isLocked}
            />
            <Table
              title="Add Unpresented Cheques"
              data={filteredExpenseData}
              markAsReconciled={markAsReconciled}
              total={sumOfArray(filteredExpenseData.map(res=>parseFloat(res.amount)))}
              suppliers={allData.suppliers}
              locked={isLocked}
            />

            {/* Lodgement entries */}
            <h2 className="text-lg font-bold text-gray-700 mt-4 mb-2">Lodgement Entries</h2>
            <table className="min-w-full bg-white shadow-sm rounded-lg text-sm">
              <thead className="bg-blue-950 text-white">
                <tr>
                  <th className="py-3 px-4">SNo</th>
                  <th className="py-3 px-4">Type</th>
                  <th className="py-3 px-4">Date</th>
                  <th className="py-3 px-4">Amount</th>
                  <th className="py-3 px-4">Description</th>
                  <th className="py-3 px-4 recon-hide-from-export recon-hide-from-print">Action</th>
                </tr>
              </thead>
              <tbody>
                {dummies.map((item, index) => (
                  <tr key={item.voucher} className="border-b hover:bg-gray-50">
                    <td className="py-2 px-4">{index + 1}</td>
                    <td className="py-2 px-4 capitalize">{item.type}</td>
                    <td className="py-2 px-4">{item.date.substring(0,10)}</td>
                    <td className="py-2 px-4">{formatToZMW(item.amount)}</td>
                    <td className="py-2 px-4">{item.description}</td>
                    <td className="py-2 px-4 recon-hide-from-export recon-hide-from-print">
                      <FaTrash 
                        onClick={() => !isLocked && delDummy(item.id)} 
                        className={isLocked ? "text-gray-300 text-xl cursor-not-allowed" : "text-red-500 text-xl cursor-pointer hover:text-red-600"} 
                        title={isLocked ? "Month is locked" : "Delete"}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="bg-gray-100 font-semibold">
                  <td colSpan="3" className="py-2 px-4">Total</td>
                  <td className="py-2 px-4">{formatToZMW(dummyTotal)}</td>
                  <td className="py-2 px-4"></td>
                  <td className="py-2 px-4 recon-hide-from-export recon-hide-from-print"></td>
                </tr>
              </tfoot>
            </table>

            <SummaryTable
              name="Adjusted cashbook balance"
              dummyTotal={dummyTotal}
              bamu={amount}
              open={open}
              totalReceipts={receipts}
              totalPayments={payments}
              closingBalance={open+receipts-payments}
            />

            {/* Prepared / Checked — table layout so PDF/Excel keep signature line spacing */}
            <table className="w-full border-collapse border-t border-gray-200 mt-6 pt-2 text-sm">
              <thead>
                <tr>
                  <th className="text-left font-semibold text-gray-800 py-3 pr-4 align-top w-1/2">
                    Prepared By
                  </th>
                  <th className="text-left font-semibold text-gray-800 py-3 pl-4 align-top w-1/2">
                    Checked By
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="align-top pr-4 pb-4">
                    <div className="space-y-5">
                      <div className="flex items-end gap-2">
                        <span className="shrink-0 text-gray-700">Name:</span>
                        <span className="flex-1 border-b border-gray-500 min-h-[1.75rem] block">&nbsp;</span>
                      </div>
                      <div className="flex items-end gap-2">
                        <span className="shrink-0 text-gray-700">Signature:</span>
                        <span className="flex-1 border-b border-gray-500 min-h-[1.75rem] block">&nbsp;</span>
                      </div>
                      <div className="flex items-end gap-2">
                        <span className="shrink-0 text-gray-700">Date:</span>
                        <span className="flex-1 border-b border-gray-500 min-h-[1.75rem] block max-w-[12rem]">&nbsp;</span>
                      </div>
                    </div>
                  </td>
                  <td className="align-top pl-4 pb-4">
                    <div className="space-y-5">
                      <div className="flex items-end gap-2">
                        <span className="shrink-0 text-gray-700">Name:</span>
                        <span className="flex-1 border-b border-gray-500 min-h-[1.75rem] block">&nbsp;</span>
                      </div>
                      <div className="flex items-end gap-2">
                        <span className="shrink-0 text-gray-700">Signature:</span>
                        <span className="flex-1 border-b border-gray-500 min-h-[1.75rem] block">&nbsp;</span>
                      </div>
                      <div className="flex items-end gap-2">
                        <span className="shrink-0 text-gray-700">Date:</span>
                        <span className="flex-1 border-b border-gray-500 min-h-[1.75rem] block max-w-[12rem]">&nbsp;</span>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Controls for bank balance and lodgements */}
          <div className="mt-4 space-y-3">
            <div className="flex flex-wrap items-center gap-2">
              <input
                type="text"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                disabled={isLocked}
                className="border border-gray-300 p-2 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                placeholder="Enter bank balance"
              />
              <button
                type="button"
                onClick={addAmount}
                disabled={isLocked}
                className="bg-blue-500 text-white px-4 py-2 rounded-lg text-sm hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Add Bank Balance
              </button>
            </div>

            <div className="flex flex-wrap items-center gap-2">
              <input
                type="text"
                value={dummy}
                onChange={(e) => setDummy(e.target.value)}
                disabled={isLocked}
                className="border border-gray-300 p-2 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                placeholder="Lodgement amount"
              />
              <input
                type="text"
                value={desc}
                onChange={(e) => setDesc(e.target.value)}
                disabled={isLocked}
                className="border border-gray-300 p-2 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                placeholder="Description"
              />
              <input
                type="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                disabled={isLocked}
                className="border border-gray-300 p-2 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
              />
              <select
                value={type}
                onChange={(e) => setType(e.target.value)}
                disabled={isLocked}
                className="border border-gray-300 p-2 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <option value="">Select type</option>
                <option value="income">Income</option>
                <option value="expense">Expense</option>
              </select>
              <button
                type="button"
                onClick={addDummy}
                disabled={isLocked}
                className="bg-blue-500 text-white px-4 py-2 rounded-lg text-sm hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Add Lodgement
              </button>
            </div>
          </div>
        </>
      )}
      </div>
    </div>
  );
}

const Table = ({ title, data, markAsReconciled, total, suppliers, locked }) => {
 
  return (
    <div className="mb-6">
    
      <table>
              <tr>
                <td> <h2 className="text-xl font-bold text-gray-700">{title}</h2></td>
              </tr>
            </table>
      <table className="min-w-full bg-white shadow-lg rounded-lg">
        <thead className="bg-blue-950 text-white">
          <tr>
            <th className="py-3 px-4">SNo</th>
            <th className="py-3 px-4">Date</th>
            <th className="py-3 px-4">Payee</th>
            <th className="py-3 px-4">Voucher</th>
            <th className="py-3 px-4">Cheque</th>
            <th className="py-3 px-4">Amount</th>
            <th className="py-3 px-4 recon-hide-from-export recon-hide-from-print">Action</th>
          </tr>
        </thead>
        <tbody>
        {[...data]
  .sort((a, b) => new Date(a.date) - new Date(b.date)) // Sort in ascending order
  .map((item, index) => (
    <tr key={item.voucher} className="border-b hover:bg-gray-100">
      <td className="py-2 px-4">{index + 1}</td>
      <td className="py-2 px-4">{item.date?.substring(0, 10)}</td>
      <td className="py-2 px-4">{suppliers.find(a=>a.id == item.paye)?.name}</td>
      <td className="py-2 px-4">{item.voucher}</td>
      <td className="py-2 px-4">{item.cheque}</td>
      <td className="py-2 px-4">{formatToZMW(item.amount)}</td>
      <td className="py-2 px-4 recon-hide-from-export recon-hide-from-print">
        {locked ? (
          <span
            className="inline-flex items-center justify-center text-gray-400"
            title="Month is locked — reconciliation cannot be changed"
          >
            {parseInt(item.recon) === 1 ? (
              <MdCancel className="text-2xl opacity-40 cursor-not-allowed" />
            ) : (
              <BiCheckCircle className="text-2xl opacity-40 cursor-not-allowed" />
            )}
          </span>
        ) : parseInt(item.recon) === 1 ? (
          <MdCancel
            role="button"
            tabIndex={0}
            onClick={() => markAsReconciled(item)}
            onKeyDown={(e) => e.key === 'Enter' && markAsReconciled(item)}
            className="text-red-500 text-2xl cursor-pointer"
          />
        ) : (
          <BiCheckCircle
            role="button"
            tabIndex={0}
            onClick={() => markAsReconciled(item)}
            onKeyDown={(e) => e.key === 'Enter' && markAsReconciled(item)}
            className="text-green-500 text-2xl cursor-pointer"
          />
        )}
      </td>
    </tr>
  ))}

        </tbody>
        <tfoot>
          <tr className="bg-gray-100 font-bold">
            <td colSpan="5" className="py-2 px-4">Total</td>
            <td className="py-2 px-4">{formatToZMW(total)}</td>
            <td className="py-2 px-4 recon-hide-from-export recon-hide-from-print"></td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

const SummaryTable = ({dummyTotal, bamu, open ,totalReceipts, totalPayments, closingBalance }) => (
  <div className="bg-white p-4 rounded-lg shadow-md my-3">
    <h2 className="text-xl font-bold text-gray-700">Adjusted Cashbook Summary</h2>
    <table className="w-full text-left border-collapse mt-2">
      <tbody>
        <tr className="border-b">
          <td className="py-2 px-4 font-bold">Opening Balance:</td>
          <td className="py-2 px-4">{formatToZMW(open)}</td>
        </tr>
        <tr className="border-b">
          <td className="py-2 px-4 font-bold">Total Receipts:</td>
          <td className="py-2 px-4">{formatToZMW(totalReceipts)}</td>
        </tr>
        <tr className="border-b">
          <td className="py-2 px-4 font-bold">Total Payments:</td>
          <td className="py-2 px-4">{formatToZMW(totalPayments)}</td>
        </tr>
        <tr className="border-b">
          <td className="py-2 px-4 font-bold">Lodgement Total:</td>
          <td className="py-2 px-4">{formatToZMW(dummyTotal)}</td>
        </tr>
        <tr className="border-t font-bold text-blue-600">
          <td className="py-2 px-4">Adjusted cashbook balance:</td>
          <td className="py-2 px-4">{formatToZMW(closingBalance + dummyTotal)}</td>
        </tr>
        <tr className="border-t font-bold text-blue-600">
          <td className="py-2 px-4">Bank Balance:</td>
          <td className="py-2 px-4">{formatToZMW(bamu)}</td>
        </tr>
        <tr className="border-t font-bold text-blue-600">
          <td className="py-2 px-4">Difference:</td>
          <td className="py-2 px-4">{formatToZMW(closingBalance  + dummyTotal - bamu)}</td>
        </tr>
      </tbody>
    </table>
  </div>
);

